import moment from 'moment'

export default {
  isVirtualShooting: state => {
    const str = state.shootingInformation && state.shootingInformation.details.vin
    return str && str.indexOf('Virtual_') === 0
  },

  username: state => {
    const firstname = (state.user && state.user.given_name) || ''
    const lastname = (state.user && state.user.family_name) || ''

    if (firstname === '' && lastname === '') return ''

    return firstname + ' ' + lastname
  },

  userEmail: state => {
    return (state.user && state.user.email) || ''
  },

  userId: state => state.user && state.user.preferred_username,

  hasSpecificAccess: state => accessName => {
    if (!accessName) return false

    const userOptions = state.userOptions

    const userAccessFound = userOptions && userOptions.find(el => el.name === accessName)

    return (userAccessFound && userAccessFound.value) || false
  },

  userInformationShooterName: state => {
    return state.shootingUserInformation.fullName
  },

  shootingInformationFormated: state => {
    if (!state.shootingInformation) return {}

    return {
      id: state.shootingInformation.id,
      created: moment(state.shootingInformation.created).format('DD/MM/YYYY - HH:mm:ss'),
      registration: state.shootingInformation.details.registration,
      productType: state.shootingInformation.productType,
      ownerId: state.shootingInformation.ownerId,
      vin: state.shootingInformation.details.vin,
      brand: state.shootingInformation.details.brand,
      model: state.shootingInformation.details.model,
      status: state.shootingStatus
    }
  }
}
